enum StatusState {
  Available = "AVAILABLE",
  Stopped = "STOPPED",
}

export default StatusState;
